"use client";
import React from 'react';
import { Grid, Typography, Box, Paper, Button, IconButton, Container } from '@mui/material';
import useTranslations from '../../hooks/useTranslation';
import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import useIsMobile from '../../hooks/useIsMobile';
import { useNavbar } from '../../contexts/NavbarContext';
import { getDictionary, getField } from '../../utils/translation/translation';
import { getSvg } from '../../utils/svgUtils';
import './style.css'
import { useRouter } from 'next/navigation';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';


export default function CRMandMarketing() {
    const isMobile = useIsMobile();
    const pathname = usePathname();
    const { companyRef, productsRef, blogRef, contactusRef, scrollToSection } = useNavbar();
    const {
        loading,
        translations,
        supportedLanguages,
        language,
        selectedLanguage,
        handleLanguageChange,
    } = useTranslations();

    const isArabic = language === 'arabic';
    const dictionary = getDictionary(translations, 'crm-marketing', language);
    const [currentProductIndex, setCurrentProductIndex] = useState(0);


    const products = [
        { title: getField(dictionary, 'our-products', language), subtitle: getField(dictionary, 'crm-marketing', language) },
        { title: getField(dictionary, 'our-products', language), subtitle: "Online Ordering" },
    ];
    const langCode = language === 'arabic' ? 'ar' : language === 'french' ? 'fr' : 'en';
    const router = useRouter();
    const [isMounted, setIsMounted] = useState(false);
    useEffect(() => {
        setIsMounted(true);
    }, []);

    const goToOnlineOrdering = () => {
        if (isMounted) {
            router.push(langCode === 'en' ? `/online-ordering` : `/${langCode}/online-ordering`);
        }
    };
    const goBrandedApps = () => {
        if (isMounted) {
            router.push(langCode === 'en' ? `/branded-apps` : `/${langCode}/branded-apps`);
        }
    };
    const [openIndex, setOpenIndex] = useState<number | null>(null);
    const handleToggle = (index: number) => {
        setOpenIndex(openIndex === index ? null : index);
    };
    const phoneNumber = '+971501286691';
    const faqsCrmAndMarketing = [
        {
            question: getField(dictionary, 'question1', language),
            answer: getField(dictionary, 'response1', language),
        },
        {
            question: getField(dictionary, 'question2', language),
            answer: getField(dictionary, 'response2', language)
        },
        {
            question: getField(dictionary, 'question3', language),
            answer: `${getField(dictionary, 'response3', language)}`
        },
        {
            question: getField(dictionary, 'question4', language),
            answer: getField(dictionary, 'response4', language),
        },
        {
            question: getField(dictionary, 'question5', language),
            answer: getField(dictionary, 'response5', language),
        },
        {
            question: getField(dictionary, 'question6', language),
            answer: getField(dictionary, 'response6', language),
        },
        {
            question: getField(dictionary, 'question7', language),
            answer: getField(dictionary, 'response7', language),
        },
    ];
    return (
        <>
            <div style={{ width: isMobile ? "95%" : "85%", margin: "auto", display: "flex", flexDirection: "column", alignItems: "center" }}>
                <div>
                    <Grid container spacing={!isMobile && isArabic ? 2 : 4} alignItems="center" padding={isMobile ? "0px " : "25px"} marginTop={"3rem"}>
                        <Grid item xs={12} sm={12} md={6} style={{ order: isArabic ? 2 : 1 }}>
                            <Paper elevation={3} className='paper-style' sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                                <Typography gutterBottom component="h1" variant="h1" width={isMobile ? "100%" : "80%"} fontWeight="bold" fontFamily="Century Gothic" fontSize={isMobile ? "1.5rem" : "2.3rem"}>
                                    {getField(dictionary, 'crm-marketing', language)}
                                </Typography>
                                {getSvg('arrowUpIcon', { mainPurple: 'var(--accent-primary)' }, { width: '70px', height: '70px' })}
                                <Typography paragraph component="h2" variant="h2" width={isMobile ? "100%" : "80%"} fontFamily="Century Gothic" fontSize={"19px"} sx={{ color: "var(--text-primary)" }}>
                                    {getField(dictionary, 'our-comprehensive', language)}
                                </Typography>
                                <Button
                                    variant='contained'
                                    sx={{
                                        backgroundColor: "var(--accent-primary)",
                                        marginTop: isMobile ? "2rem" : "3rem",
                                        transition: 'background-color 0.3s ease',
                                        '&:hover': {
                                            backgroundColor: "var(--accent-secondary)",
                                        },
                                    }}
                                >
                                    <a href="#" rel="prefetch" onClick={() => scrollToSection(contactusRef)} style={{ textDecoration: 'none', color: "white" }}>
                                        {getField(dictionary, 'request-demo', language)}
                                    </a>

                                </Button>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} md={6} style={{ order: !isMobile && isArabic ? 1 : 2, }}>
                            <Box display="flex" justifyContent="center">
                                <img src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/crm.png`} width={"100%"} height={"auto"} style={{ maxWidth: "90%" }} alt="Illustration of a home page" />
                            </Box>
                        </Grid>
                    </Grid >
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "20%" }}>
                            <div style={{ cursor: 'pointer' }} onClick={goToOnlineOrdering}>
                                {getSvg('leftArrowIcon', { yellow: 'var(--accent-secondary)' }, { width: isMobile ? "40px" : "50px", height: isMobile ? "40px" : "50px" }, {})}
                            </div>
                            <div style={{ fontSize: isMobile ? "10px" : "1rem", color: "var(--text-secondary)", display: "flex", justifyContent: "center", alignItems: "center", width: isMobile ? "100%" : "95%", marginTop: "10px" }}> Online Ordering</div>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                flexGrow: 1,
                                textAlign: "center",
                            }}
                        >
                            <p style={{ color: "var(--text-primary)", fontFamily: "Century Gothic", fontSize: isMobile ? "12px" : "1.2rem", margin: 0, fontWeight: "bold" }}>
                                {products[currentProductIndex].title}
                            </p>
                            <p style={{ color: "var(--text-primary)", fontFamily: "Century Gothic", fontSize: isMobile ? "14px" : "1.7rem", margin: 0, fontWeight: "bold" }}>
                                {products[currentProductIndex].subtitle}
                            </p>
                        </div>

                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "20%" }}>
                            <div style={{ cursor: 'pointer' }} onClick={goBrandedApps}>
                                {getSvg('rightArrowIcon', { yellow: 'var(--accent-secondary)' }, { width: isMobile ? "40px" : "50px", height: isMobile ? "40px" : "50px" }, {})}
                            </div>
                            <div style={{ fontSize: isMobile ? "10px" : "1rem", color: "var(--text-secondary)", display: "flex", justifyContent: "center", alignItems: "center", width: isMobile ? "100%" : "95%", marginTop: "10px" }}> Branded Apps</div>

                        </div>

                    </div>



                </div>
                <div>
                    <Grid container justifyContent={"space-between"} spacing={!isMobile && isArabic ? 2 : 4} padding={isMobile ? "0px " : "25px"} marginTop={"2rem"} paddingBottom={isMobile ? "0rem" : "2rem"}>
                        <Grid
                            item
                            xs={12}
                            md={6}
                            lg={6}
                            style={{
                                order: isArabic ? 2 : 1,
                                display: 'flex',
                                flexDirection: 'column',

                            }}
                        >
                            <Typography
                                gutterBottom
                                component="h3"
                                variant="h3"
                                fontWeight="bold"
                                fontFamily="Century Gothic"
                                fontSize={"25px"}
                                sx={{ color: "var(--text-primary)" }}
                                textAlign={"left"}
                                position="relative"
                            >
                                {getField(dictionary, 'automated-customer', language)}
                            </Typography>
                            <Typography
                                paragraph
                                component="h3"
                                variant="h3"
                                fontFamily="Century Gothic"
                                fontSize={"20px"}
                                sx={{ color: "var(--text-primary)" }}
                                textAlign={"left"}
                                marginTop={isMobile ? "1rem" : "3rem"}
                            >
                                {getField(dictionary, 'boost-your-customer', language)}
                                <br />  <br />
                                {getField(dictionary, 'create-tailored-campaigns', language)}

                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={6} lg={6} style={{ order: !isMobile && isArabic ? 1 : 2, position: 'relative' }}>
                            <Box display="flex" justifyContent="center" alignItems="center" position="relative" style={{ height: isMobile ? '80%' : '70%' }}>
                                {/* {!isMobile && (
                                          <div style={{ position: 'absolute', top: "0%", left: "30%", zIndex: 1 }}>
                                              <img
                                                  src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/Repeat Grid 27.svg`}
                                                  alt="grid"
                                                  width={"50%"}
                                                  height={"60%"}
                                              />
                                          </div>
                                      )} */}
                                <img
                                    src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/eng-temp.png`}
                                    width={isMobile ? "100%" : "100%"}
                                    height={isMobile ? "100%" : "100%"}
                                    alt="Illustration of a home page"
                                    style={{ position: 'relative', zIndex: 2, marginTop: isMobile ? "0" : "10%" }}
                                />

                            </Box>
                        </Grid>
                    </Grid >
                </div>
            </div>
            <div>
                <Box className="section-light-purple-bg" sx={{ width: "100%", display: "flex", justifyContent: isMobile ? "space-between" : "center" }}>
                    <Grid container alignItems="center" justifyContent={isMobile ? "space-between" : "center"} padding="25px" marginTop="0rem">
                        <Grid item xs={12} md={4} sm={6} lg={4} style={{ position: 'relative', order: isMobile ? 2 : 2, }}>
                            <Box display="flex" justifyContent="center" alignItems="center" style={{ height: '70%' }}>
                                {/* {!isMobile && (
                                       <div style={{ position: 'absolute', top: "-10%", right: "0%", zIndex: 1 }}>
                                           <img
                                               src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/Repeat Grid 27.svg`}
                                               alt="grid"
                                               width={"600px"}
                                               height={"600px"}
                                           />
                                       </div>
                                   )} */}
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <img
                                        src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/enhance1.png`}
                                        width="100%"
                                        height="100%"
                                        alt="Illustration of a home page"
                                        style={{ position: 'relative', zIndex: 2, marginBottom: 0, maxWidth: isMobile ? "70%" : "70%" }}
                                    />
                                    <img
                                        src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/enhance2.png`}
                                        width="100%"
                                        height="100%"
                                        alt="Illustration of a home page"
                                        style={{ position: 'relative', zIndex: 2, marginTop: 0, maxWidth: isMobile ? "70%" : "70%" }}
                                    />
                                </div>

                                <img
                                    src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/enhance3.png`}
                                    width={isMobile ? "40%" : "30%"}
                                    height="auto"
                                    alt="Additional Illustration"
                                    style={{
                                        position: 'absolute',
                                        top: '20%',
                                        left: '45%',
                                        zIndex: 3,
                                        margin: '0',
                                    }}
                                />
                            </Box>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={6}
                            sm={6}
                            lg={6}
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                textAlign: 'left',
                                justifyContent: 'center',
                                order: isMobile ? 1 : 2,
                            }}
                        >
                            <Typography
                                gutterBottom
                                component="h3"
                                variant="h3"
                                fontWeight="bold"
                                fontFamily="Century Gothic"
                                fontSize={"25px"}
                                sx={{ color: "var(--text-primary)" }}
                            >
                                {getField(dictionary, 'real-time-customer', language)}
                            </Typography>

                            <Typography
                                paragraph
                                component="h3"
                                variant="h3"
                                fontFamily="Century Gothic"
                                fontSize={"20px"}
                                sx={{ color: "var(--text-primary)" }}
                            >
                                {getField(dictionary, 'integrate-customer-feedback', language)}
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>
            </div>
            <div style={{ width: isMobile ? "95%" : "85%", margin: "auto", display: "flex", flexDirection: "column", alignItems: "center" }}>
                <div>
                    <Grid container justifyContent={"space-between"} spacing={!isMobile && isArabic ? 2 : 4} padding={isMobile ? "0px " : "25px"} marginTop={"2rem"} >
                        <Grid
                            item
                            xs={12}
                            md={6}
                            lg={6}
                            style={{
                                order: isArabic ? 2 : 1,
                                display: 'flex',
                                flexDirection: 'column',

                            }}
                        >
                            <Typography
                                gutterBottom
                                component="h3"
                                variant="h3"
                                fontWeight="bold"
                                fontFamily="Century Gothic"
                                fontSize={"25px"}
                                sx={{ color: "var(--text-primary)" }}
                                textAlign={"left"}
                                position="relative"
                            >
                                {getField(dictionary, 'affiliate-marketing', language)}
                            </Typography>
                            <Typography
                                paragraph
                                component="h3"
                                variant="h3"
                                fontFamily="Century Gothic"
                                fontSize={"20px"}
                                sx={{ color: "var(--text-primary)" }}
                                textAlign={"left"}
                                marginTop={isMobile ? "1rem" : "3rem"}
                            >
                                {getField(dictionary, 'maximize-you-roi', language)}

                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={6} lg={6} style={{ order: !isMobile && isArabic ? 1 : 2, position: 'relative' }}>
                            <Box display="flex" justifyContent="center" alignItems="center" position="relative" style={{ height: isMobile ? '80%' : '70%' }}>
                                {/* {!isMobile && (
                                <div style={{ position: 'absolute', top: "0%", left: "30%", zIndex: 1 }}>
                                    <img
                                        src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/Repeat Grid 27.svg`}
                                        alt="grid"
                                        width={"50%"}
                                        height={"60%"}
                                    />
                                </div>
                            )} */}
                                <img
                                    src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/aff-mark.png`}
                                    width={isMobile ? "100%" : "90%"}
                                    height={isMobile ? "100%" : "100%"}
                                    alt="Illustration of a home page"
                                    style={{ position: 'relative', zIndex: 2, marginTop: isMobile ? "0" : "10%" }}
                                />

                            </Box>
                        </Grid>
                    </Grid >
                </div>
            </div>
            <div className="faq-wrapper" style={{ width: isMobile ? "95%" : "100%", margin: "auto", marginTop: "2rem", display: "flex", flexDirection: "column", alignItems: "center" }}>
                <div>
                    <Box style={{ width: "100%", display: "flex", justifyContent: isMobile ? "space-between" : "center", paddingBottom: "4rem" }}>
                        <div className='container' style={{ padding: "1rem" }}>
                            <Box className="box-container" sx={{ width: isMobile ? "95%" : "900px" }}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <div style={{ display: "flex", alignItems: "center", flexDirection: "column", lineHeight: 1 }}>
                                        <p className='faq-title'>{getField(dictionary, 'faq', language)}  </p>
                                        <p className="fap-under-title" style={{ fontSize: isMobile ? "15px" : "19px" }}> {getField(dictionary, 'what-are-you-looking-for', language)} </p>
                                    </div>
                                    <div><SearchIcon sx={{ fontSize: "70px", color: "var(--accent-secondary)" }} /> </div>
                                </div>
                                <Grid container spacing={0} alignItems="center" justifyContent="center" marginTop="1rem">
                                    <Grid item xs={12} md={5} justifyContent={isMobile ? "center" : "flex-start"}>
                                        <Box >
                                            <div style={{ display: "flex", alignItems: "center", justifyContent: isMobile ? "center" : "flex-start", marginTop: "1rem" }}>
                                                <div >
                                                    {getSvg('arrowDownYellowIcon', { yellow: 'var(--accent-secondary)', darkPurple: 'var(--accent-primary)' }, { width: isMobile ? 70 : 100, height: isMobile ? 70 : 100 }, { transform: isMobile ? "translateX(2rem) " : "translateX(3rem)" })}
                                                </div>
                                                <div style={{ marginLeft: "1rem" }}>
                                                    <p style={{ fontSize: "15px", color: "var(--text-primary)", fontFamily: "Century Gothic", margin: 0 }}> {getField(dictionary, 'cant-find-what', language)}</p>
                                                    <p style={{ width: "90%", fontSize: isMobile ? "15px" : "17px", fontWeight: "bold", color: "var(--text-primary)", fontFamily: "Century Gothic", margin: 0 }}>
                                                        {getField(dictionary, 'we-would-like', language)}
                                                    </p>
                                                    <div style={{

                                                        marginTop: isMobile ? "2rem" : "4rem",

                                                    }} className='chat-container'>
                                                        <span className='whatsapp-container'>
                                                            {getSvg('chattingIcon', { yellow: 'var(--accent-secondary)', darkPurple: 'var(--accent-primary)' }, { width: 60, height: 60 }, { display: "inline-block" })}
                                                            <span><a href={`https://wa.me/${phoneNumber}`} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                                                                {isArabic ?
                                                                    (<><span >!</span>    {getField(dictionary, 'chat-with-us', language)} </>)
                                                                    :
                                                                    (<>   {getField(dictionary, 'chat-with-us', language)} <span >!</span></>)}
                                                            </a></span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <Box style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                            {faqsCrmAndMarketing.map((question, index) => (
                                                <>
                                                    <Box key={index} className='quest-box' style={{ direction: isArabic ? 'rtl' : 'ltr', textAlign: isArabic ? 'right' : 'left' }}>
                                                        <div><p className='question' style={{ fontSize: isMobile ? "15px" : "15px" }}>{question.question}</p></div>
                                                        <div>
                                                            <IconButton className='question-icon' onClick={() => handleToggle(index)} aria-label="add or remove button">
                                                                {openIndex === index ? <RemoveIcon /> : <AddIcon />}
                                                            </IconButton>
                                                        </div>
                                                    </Box>
                                                    {openIndex === index && (
                                                        <Box className='answr-box' style={{ direction: isArabic ? 'rtl' : 'ltr', textAlign: isArabic ? 'right' : 'left' }}>
                                                            <p style={{ fontSize: isMobile ? "14px" : "16px", color: "var(--text-primary)", fontFamily: "Century Gothic", margin: 0 }} dangerouslySetInnerHTML={{ __html: question.answer }} />
                                                        </Box>
                                                    )}
                                                </>
                                            ))}
                                        </Box>
                                    </Grid>
                                </Grid>



                            </Box>
                        </div>
                    </Box>
                </div>
            </div>
        </>
    )
}